"use client";

import React, { useState } from "react";
import { ShieldCheck, Truck, ThermometerSun, Shirt, ScanEye, PackageCheck, CircleCheck } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  id: "item-1",
  title: "1. Svoz a bezkontaktní příjem",
  icon: Truck,
  content: "Náš proces začíná u vás. Používáme oddělené přepravní vaky a specializované vozy pro špinavé a čisté prádlo, abychom zcela vyloučili riziko křížové kontaminace."
}, {
  id: "item-2",
  title: "2. Termodezinfekční praní",
  icon: ThermometerSun,
  content: "Praní probíhá v tunelových pračkách s přesně řízeným dávkováním certifikovaných detergentů. Proces termodezinfekce při teplotách nad 70°C garantuje eliminaci 99,9% bakterií a virů v souladu s nejpřísnějšími hygienickými normami RABC."
}, {
  id: "item-3",
  title: "3. Průmyslové žehlení a mandlování",
  icon: Shirt,
  content: "Využíváme vysokokapacitní plynové mandly, které prádlo nejen dokonale vyžehlí, ale tepelným šokem jej finálně sterilizují. Výsledkem je dokonale hladké, svěží a hygienicky čisté prádlo připravené pro hotelový provoz."
}, {
  id: "item-4",
  title: "4. Třístupňová kontrola kvality",
  icon: ScanEye,
  content: "Každý kus prádla prochází vizuální kontrolou na světelném stole a automatickou detekcí skvrn. Měříme pH prádla a stupeň bělosti, abychom zajistili konzistentní kvalitu, kterou vaši hosté očekávají."
}, {
  id: "item-5",
  title: "5. Hygienické balení a expedice",
  icon: PackageCheck,
  content: "Čisté prádlo je okamžitě baleno do ochranných fólií, které jej chrání před prachem a vlhkostí během transportu. Naše noční logistika zajišťuje, že čerstvé prádlo máte k dispozici ještě před začátkem ranní směny."
}];
export default function HighestHygieneStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [activeItem, setActiveItem] = useState("item-1");
  return;
}